import { Client, HttpClient, RouteGenerator } from "silver";
import { StorageKeyObserver } from "shared/StorageKeyObserver";

const CSRF_FAILURE_HEADER = "VND-MYON-CSRF-Protection";

export class UserUnauthorizedEventHandler {
	private isNavigating: boolean = false;
	constructor(
		private client: Client,
		private httpClient: HttpClient,
		private router: RouteGenerator,
		private userIdObserver: StorageKeyObserver<number|null>,

	) { }

	private urlIsLogout(url: string): boolean {
		if (!url) {
			return false;
		}
		try {
			const route = this.router.parse(url);
			if (!route) {
				return false;
			}
			return (route.path === "login\\index" && route.parameters.hasOwnProperty("logoutReason"));
		} catch (er) {
			console.warn(er);
			return false;
		}
	}

	public listen(): void {
		this.httpClient.onResponse(({ response }) => {
			if (this.isNavigating) {
				return;
			}
			const url = response.url;
			if (this.urlIsLogout(url)) {
				this.openRedirect(url);
			}


			const csrfHeader = response.headers.get(CSRF_FAILURE_HEADER);
			if (response.status === 403 && csrfHeader !== null) {
				this.refreshUserAuthorization();
			}
		});

		this.userIdObserver.onChange(() => this.refreshUserAuthorization());
	}

	private openRedirect(url: string): void {
		if (this.isNavigating) {
			return;
		}
		this.isNavigating = true;
		this.client.open(url);
	}

	private refreshUserAuthorization(): void {
		if (this.isNavigating) {
			return;
		}
		this.isNavigating = true;
		this.client.reload();
	}
}
